import { Link } from '@tanstack/react-router'
import { Icon } from '../icons/Icon.jsx'
import { SystemStatusBadge } from '../ui/Badges.jsx'
import { SystemTile } from '../ui/SystemTile.jsx'
import l from './library.module.css'

function subline(system) {
  if (system.status === 'none') return `${system.categoryLabel} · no skill yet`
  return [system.vendor, system.categoryLabel].filter(Boolean).join(' · ')
}

/**
 * Library card, in the grid and the side list. The name is a stretched link;
 * `showEdit` adds an Edit button that opens the system in edit mode.
 */
export function SystemCard({ system, selected, canEdit, onAddSkill, showEdit }) {
  const className = [
    l.card,
    selected ? l.cardSelected : '',
    system.status === 'none' ? l.cardNone : '',
    system.optimistic ? l.cardOptimistic : '',
  ].join(' ')
  return (
    <div className={className}>
      <div className={l.cardTop}>
        <SystemTile system={system} size="list" />
        <span className={l.cardText}>
          <Link
            to="/library/$slug"
            params={{ slug: system.slug }}
            className={l.cardLink}
            aria-current={selected ? 'true' : undefined}
            disabled={system.optimistic}
          >
            {system.name}
          </Link>
          <span className={l.cardSub}>{subline(system)}</span>
        </span>
        <SystemStatusBadge status={system.status} />
        {showEdit && canEdit ? (
          <Link
            to="/library/$slug"
            params={{ slug: system.slug }}
            search={{ edit: true }}
            className={`btn btn-ghost ${l.cardButton}`}
            aria-label={`Edit ${system.name}`}
            disabled={system.optimistic}
          >
            <Icon name="edit" size={14} strokeWidth={1.6} />
            Edit
          </Link>
        ) : null}
      </div>
      {system.status === 'ready' ? (
        <div className={l.cardMeta}>
          <span>Skill v{system.published.label}</span>
          <span>Contract {system.published.contract ?? '—'}</span>
          <span>
            {system.published.files} {system.published.files === 1 ? 'file' : 'files'}
          </span>
          {system.draft ? <span>· draft in progress</span> : null}
        </div>
      ) : system.status === 'draft' ? (
        <div className={l.cardBottom}>
          <span>
            Draft skill · Contract {system.draft.contract ?? '—'} · {system.draft.files}{' '}
            {system.draft.files === 1 ? 'file' : 'files'}
          </span>
        </div>
      ) : (
        <div className={l.cardBottom}>
          <span>Build it from the skill builder prompt</span>
          {canEdit ? (
            <button type="button" className={`btn btn-dark ${l.cardButton}`} onClick={onAddSkill} disabled={system.optimistic}>
              Add skill
            </button>
          ) : null}
        </div>
      )}
    </div>
  )
}
